module.exports = __webpack_public_path__ + "assets/img/3.b6c275d0.png";